export default __webpack_public_path__ + "static/FundeSur-efc7c9d86573dfa4feb757b91928bbcc.webp";